import axios from 'axios'
import userService from './userService'
import { getEnvVar } from '@/assets/js/helpers'

const CancelToken = axios.CancelToken
let cancelClubInfo

const apiClient = axios.create({
  baseURL: getEnvVar('VUE_APP_API_URL')
})

apiClient.interceptors.request.use((config) => {
  config.params = config.params || {}
  if (userService.debugUserId) {
    config.params.debugUser = userService.debugUserId
  }
  return config
})

export default {
  createClub (data) {
    return apiClient.post('/club/create', data)
  },
  editClub (data) {
    return apiClient.post('/club/edit-club', data)
  },
  checkNameIsExist (name) {
    return apiClient.post('/club/check-exist', {
      params: {
        name
      }
    })
  },
  getClubInfo (id) {
    if (cancelClubInfo) {
      cancelClubInfo('canceled')
    }
    return apiClient.post(`/get-club?code=${id}`, null, {
      cancelToken: new CancelToken(function executor (c) {
        cancelClubInfo = c
      })
    })
  },
  getClubMembers ({ code, searchString, count, offset }) {
    return apiClient.post('/get-club-members', {
      clubCode: code,
      searchString,
      count,
      offset
    })
  },
  setClubBackground ({ clubId, image, imageName }) {
    return apiClient.post('/club/set-background', {
      clubId,
      image,
      imageName
    })
  },
  joinClub ({ clubId }) {
    return apiClient.post(`/club/join-request?clubId=${clubId}`)
  },
  leaveClub ({ clubId }) {
    return apiClient.post(`/club/leave-club?clubId=${clubId}`)
  },
  acceptAgreement ({ clubCode }) {
    return apiClient.post(`/club/apply-agreement?clubCode=${clubCode}`, {}, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}
